(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-badelatschen-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const getMoney = (cents, format) => {
      if (typeof window.formatMoney === 'function') return window.formatMoney(cents, format);
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    };

    const initializeBundleCard = async (card) => {
      if (card.dataset.pmBundleReady || card.dataset.pmBundleLoading) return;
      const bundleOutside = card.closest('.pm-bundle-outside');
      if (bundleOutside?.dataset.pmBundleBlocked === 'true') return;
      card.dataset.pmBundleLoading = 'true';

      try {
        const requestUrl = new URL(card.dataset.recommendationsUrl, window.location.origin);
        requestUrl.searchParams.set('product_id', card.dataset.currentProductId);
        requestUrl.searchParams.set('limit', '1');
        requestUrl.searchParams.set('intent', 'complementary');

        const recommendationResponse = await fetch(requestUrl, {
          credentials: 'omit',
          headers: { Accept: 'application/json' },
        });
        if (!recommendationResponse.ok) throw new Error('Add-on recommendation failed');

        const recommendationData = await recommendationResponse.json();
        const addOnProduct = recommendationData.products?.[0];
        const availableVariants = addOnProduct?.variants?.filter((variant) => variant.available) || [];
        if (!addOnProduct || availableVariants.length === 0) {
          card.closest('.pm-bundle-outside')?.remove();
          return;
        }

        const bundleVariant = card.querySelector('[data-pm-bundle-variant]');
        const currentColor = card.querySelector('[data-pm-current-color]');
        const currentSize = card.querySelector('[data-pm-current-size]');
        const currentImage = card.querySelector('[data-pm-current-image] img');
        const currentVariants = JSON.parse(card.querySelector('[data-pm-current-variants]')?.textContent || '[]');
        const options = card.querySelector('[data-pm-bundle-options]');
        const image = card.querySelector('[data-pm-bundle-image]');
        const button = card.querySelector('[data-pm-bundle-submit]');
        const error = card.querySelector('[data-pm-bundle-error]');
        const productPath = `${window.Shopify?.routes?.root || '/'}products/${addOnProduct.handle}`;

        card.querySelectorAll('[data-pm-bundle-link]').forEach((link) => (link.href = productPath));
        card.querySelector('[data-pm-bundle-title]').textContent = addOnProduct.title;
        bundleVariant.replaceChildren();

        const getVariantImage = (variant) => {
          return variant.featured_image?.src || variant.featured_media?.preview_image?.src || addOnProduct.featured_image || '';
        };

        const getCurrentVariantImage = (variant) => {
          return variant.featured_image?.src || variant.featured_media?.preview_image?.src || currentImage?.src || '';
        };

        const updateCurrentVariant = () => {
          const matchingSizes = currentVariants.filter((variant) => (variant.option1 || variant.options?.[0]) === currentColor.value);
          Array.from(currentSize.options).forEach((sizeOption) => {
            const matchingVariant = matchingSizes.find((variant) => (variant.option2 || variant.options?.[1]) === sizeOption.value);
            sizeOption.disabled = !matchingVariant?.available;
          });

          let currentVariant = matchingSizes.find((variant) => (variant.option2 || variant.options?.[1]) === currentSize.value && variant.available);
          if (!currentVariant) {
            currentVariant = matchingSizes.find((variant) => variant.available);
            if (currentVariant) currentSize.value = currentVariant.option2 || currentVariant.options?.[1];
          }

          if (!currentVariant) return;
          card.dataset.currentVariantId = currentVariant.id;
          card.dataset.currentVariantPrice = currentVariant.price;

          const currentPrice = Number(currentVariant.price);
          const currentCompareAtPrice = Number(currentVariant.compare_at_price || 0);
          card.dataset.currentVariantCompareAtPrice = currentCompareAtPrice > currentPrice ? currentCompareAtPrice : currentPrice;

          const variantImage = getCurrentVariantImage(currentVariant);
          if (currentImage && variantImage) {
            currentImage.removeAttribute('srcset');
            currentImage.src = variantImage;
            currentImage.alt = `${card.querySelector('.pm-bundle-card__current-copy > span')?.textContent || ''} – ${currentVariant.title}`;
          }
        };

        availableVariants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title;
          option.dataset.image = getVariantImage(variant);
          option.selected = variant.title.toLowerCase() === 'black';
          bundleVariant.append(option);
        });

        if (!bundleVariant.value) bundleVariant.value = String(availableVariants[0].id);
        options.hidden = addOnProduct.has_only_default_variant === true;

        const updateVariantPresentation = () => {
          const variant = availableVariants.find((item) => String(item.id) === bundleVariant.value) || availableVariants[0];
          const originalPrice = Number(variant.price);
          const saving = Math.round(originalPrice * 0.2);
          const discountedPrice = originalPrice - saving;
          const addOnCompareAtPrice = Number(variant.compare_at_price || 0) > originalPrice
            ? Number(variant.compare_at_price)
            : originalPrice;
          const bundleTotal = Number(card.dataset.currentVariantPrice) + discountedPrice;
          const compareTotal = Number(card.dataset.currentVariantCompareAtPrice) + addOnCompareAtPrice;
          const totalSaving = Math.max(0, compareTotal - bundleTotal);
          const savingPercentage = compareTotal > 0 ? Math.round((totalSaving / compareTotal) * 100) : 0;
          const selectedOption = bundleVariant.selectedOptions[0];
          const variantImage = selectedOption?.dataset.image || getVariantImage(variant);

          image.removeAttribute('srcset');
          image.src = variantImage;
          image.alt = `${addOnProduct.title} – ${variant.title}`;
          card.querySelectorAll('[data-pm-bundle-link]').forEach((link) => {
            link.href = `${productPath}?variant=${variant.id}`;
          });
          card.querySelector('[data-pm-bundle-total]').textContent = getMoney(bundleTotal, card.dataset.moneyFormat);
          card.querySelector('[data-pm-bundle-total-compare]').textContent = getMoney(compareTotal, card.dataset.moneyFormat);
          card.querySelector('[data-pm-bundle-saving]').textContent = card.dataset.savingTemplate.replace('__AMOUNT__', getMoney(totalSaving, card.dataset.moneyFormat));
          card.querySelector('[data-pm-bundle-badge]').textContent = card.dataset.savingPercentageTemplate.replace('__PERCENTAGE__', savingPercentage);
        };

        const updateBundlePresentation = () => {
          updateCurrentVariant();
          updateVariantPresentation();
        };

        currentColor?.addEventListener('change', updateBundlePresentation);
        currentSize?.addEventListener('change', updateBundlePresentation);
        bundleVariant.addEventListener('change', updateVariantPresentation);
        bundleVariant.addEventListener('input', updateVariantPresentation);
        updateBundlePresentation();
        if (bundleOutside?.dataset.pmBundleBlocked === 'true') return;
        card.hidden = false;
        card.dataset.pmBundleReady = 'true';

        button?.addEventListener('click', async () => {
          const productForm = document.getElementById(`product-form-${card.dataset.sectionId}`);

          if (!productForm || !card.dataset.currentVariantId || !bundleVariant) {
            error.textContent = card.dataset.errorMessage;
            error.hidden = false;
            return;
          }

          if (!productForm.checkValidity()) {
            productForm.reportValidity();
            return;
          }

          const formData = new FormData(productForm);
          const properties = { _bundle_offer: 'badelatschen-fischerhut-20' };
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== '') properties[match[1]] = value;
          });

          const quantity = Number(formData.get('quantity') || 1);
          const items = [
            {
              id: Number(card.dataset.currentVariantId),
              quantity,
              properties,
            },
            {
              id: Number(bundleVariant.value),
              quantity: 1,
              properties: { _bundle_offer: 'badelatschen-fischerhut-20' },
            },
          ];

          button.disabled = true;
          button.classList.add('is-loading');
          error.hidden = true;

          try {
            const response = await fetch(card.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({ items }),
            });

            if (!response.ok) throw new Error('Bundle add failed');

            const discountResponse = await fetch(card.dataset.cartUpdateUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({ discount: card.dataset.discountCode }),
            });

            if (!discountResponse.ok) throw new Error('Bundle discount failed');

            const cartResponse = await fetch(card.dataset.cartUrl, {
              headers: { Accept: 'application/json' },
            });
            const cart = await cartResponse.json();

            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

            window.setTimeout(() => {
              const drawer = document.querySelector('cart-drawer');
              if (typeof drawer?.open === 'function') drawer.open();
              else document.getElementById('cart-drawer-toggle')?.click();
            }, 350);

            button.disabled = false;
            button.classList.remove('is-loading');
          } catch (bundleError) {
            error.textContent = card.dataset.errorMessage;
            error.hidden = false;
            button.disabled = false;
            button.classList.remove('is-loading');
          }
        });
      } catch (loadError) {
        card.closest('.pm-bundle-outside')?.remove();
      } finally {
        delete card.dataset.pmBundleLoading;
      }
    };

    const initializeBundleCards = (root = document) => {
      root.querySelectorAll('[data-pm-bundle]').forEach((card) => {
        initializeBundleCard(card);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeBundleCards());
    } else {
      initializeBundleCards();
    }

    document.addEventListener('shopify:section:load', (event) => initializeBundleCards(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-badelatschen-buybox-part"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeInlineQuantity = (root = document) => {
      root.querySelectorAll('.pm-inline-quantity .qty:not([data-pm-inline-quantity-ready])').forEach((input) => {
        input.dataset.pmInlineQuantityReady = 'true';
        input.addEventListener('change', (event) => event.stopPropagation());
      });
    };

    const getDirectBuyboxChild = (element, buybox) => {
      let child = element;
      while (child && child.parentElement !== buybox) child = child.parentElement;
      return child;
    };

    const positionProductUsps = (root = document) => {
      root.querySelectorAll('.thb-product-detail').forEach((productSection) => {
        const nativeUsps = productSection.querySelector('[data-pm-media-usps]');
        if (nativeUsps) {
          productSection.querySelector('.product-information--inner .lb-pdp-benefits')?.remove();
          return;
        }
        const existingOverlay = productSection.querySelector('.pm-media-usp-overlay');
        const benefits = productSection.querySelector('.product-information--inner .lb-pdp-benefits')
          || existingOverlay?.querySelector('.lb-pdp-benefits');
        const mediaSlides = Array.from(productSection.querySelectorAll('.product-images__slide'));
        const firstMedia = mediaSlides.find((slide) => slide.classList.contains('is-active') && slide.getBoundingClientRect().width > 0)
          || mediaSlides.find((slide) => slide.getBoundingClientRect().width > 0)
          || mediaSlides[0];
        if (!benefits || !firstMedia) return;

        const overlay = existingOverlay || document.createElement('div');
        overlay.className = 'pm-media-usp-overlay';
        if (!overlay.contains(benefits)) overlay.append(benefits);
        if (overlay.parentElement !== firstMedia) firstMedia.append(overlay);
      });
    };

    const updateConditionalModules = (root = document) => {
      root.querySelectorAll('.thb-product-detail').forEach((productSection) => {
        const buybox = productSection.querySelector('.product-information--inner');
        const bundleOutside = productSection.querySelector('.pm-bundle-outside');
        if (!buybox || !bundleOutside) return;

        const config = buybox.querySelector('.pm-buybox-config');
        const hasEasify = Boolean(productSection.querySelector('.easify-product-options, .tpo_option-set-wrapper.tpo_has-option-set, [class*="easify-box"]'));
        const hasUpsell = config?.dataset.pmHasUpsell === 'true' || Boolean(productSection.querySelector('.addon-card, onetick-group-checkboxes, .checkbox-wrapper'));
        const addToCart = productSection.querySelector('.single-add-to-cart-button');
        const designerButtons = Array.from(document.querySelectorAll('[id^="product-designer-"] button'));
        const isCustomizer = [addToCart, ...designerButtons].some((button) =>
          (button?.textContent || '').trim().toLowerCase().includes('jetzt anpassen')
        );
        const isBlocked = hasEasify || hasUpsell || isCustomizer;

        bundleOutside.hidden = isBlocked;
        bundleOutside.dataset.pmBundleBlocked = String(isBlocked);
      });
    };

    const formatSharedMoney = (cents, format) => {
      if (typeof window.formatMoney === 'function') return window.formatMoney(cents, format);
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(cents || 0) / 100);
    };

    const updateSharedPrice = (priceBox, variant) => {
      if (!priceBox || !variant) return;
      const current = priceBox.querySelector('[data-pm-price-current]');
      const compare = priceBox.querySelector('[data-pm-price-compare]');
      const saving = priceBox.querySelector('[data-pm-price-saving]');
      const price = Number(variant.price || 0);
      const comparePrice = Number(variant.compare_at_price || 0);

      if (current) current.textContent = formatSharedMoney(price, priceBox.dataset.moneyFormat);
      if (comparePrice > price) {
        const percentage = Math.round(((comparePrice - price) / comparePrice) * 100);
        compare.textContent = formatSharedMoney(comparePrice, priceBox.dataset.moneyFormat);
        saving.textContent = (priceBox.dataset.savingTemplate || 'Spare __PERCENTAGE__ %').replace('__PERCENTAGE__', percentage);
        compare.hidden = false;
        saving.hidden = false;
      } else {
        compare.hidden = true;
        saving.hidden = true;
      }
    };

    const initializeSharedPrices = (root = document) => {
      root.querySelectorAll('[data-pm-shared-price]').forEach((priceBox) => {
        if (priceBox.dataset.pmPriceReady) return;
        priceBox.dataset.pmPriceReady = 'true';
      });
    };

    const deduplicateBuyboxCore = (root = document) => {
      root.querySelectorAll('.product-information--inner').forEach((buybox) => {
        ['.pm-buybox-social', '.pm-buybox-title', '.pm-shop-rating', '.pm-buybox-usps', '.pm-buybox-price', '.pm-buybox-delivery', '.pm-buybox-payments', '.pm-buybox-benefits', '.pm-buybox-product-reviews'].forEach((selector) => {
          buybox.querySelectorAll(selector).forEach((element, index) => {
            if (index > 0) element.remove();
          });
        });
      });
    };

    const moveSecondaryBuyboxContent = (root = document) => {
      root.querySelectorAll('.product-information--inner').forEach((buybox) => {
        const information = buybox.closest('.product-information');
        if (!information) return;
        let secondary = information.nextElementSibling;
        if (!secondary?.classList.contains('pm-product-secondary')) {
          secondary = document.createElement('div');
          secondary.className = 'pm-product-secondary';
          information.insertAdjacentElement('afterend', secondary);
        }

        Array.from(buybox.children).forEach((child) => {
          if (child.matches('style, script, noscript, .pm-buybox-config, pickup-availability')) return;
          const isInlineOffer = child.matches('.patch-picker')
            || Boolean(child.querySelector('.patch-picker'))
            || (child.textContent.includes('Heute 3 für 2 Aktion') && child.textContent.includes('NIMM3'));
          const isProductConfiguration = child.matches('.form-switcher')
            || Boolean(child.querySelector('.form-switcher'));
          const isAlwaysSecondary = child.matches('product-recommendations, collapsible-row, side-panel-links, coupon-code, .product--text, .product-short-description, .product-information--image, .product--icon-list, .product--pros-cons, .product-fit-guide, .product--payment-security');
          const isCore = child.matches('h1, .pm-buybox-title, .pm-buybox-social, .pm-shop-rating, .pm-buybox-usps, variant-selects, .pm-buybox-price, product-form, .product-form, .addon-card, onetick-group-checkboxes, .checkbox-wrapper, .easify-product-options, .tpo_option-set-wrapper, .pm-buybox-delivery, .pm-buybox-payments, .pm-buybox-benefits, .pm-buybox-product-reviews')
            || child.querySelector('.single-add-to-cart-button, .addon-card, onetick-group-checkboxes, .checkbox-wrapper, .easify-product-options, .tpo_option-set-wrapper, .biscuits-bundle-form, [class*="easify-box"], .quantity, quantity-input, .jdgm-review-snippet')
            || isInlineOffer
            || isProductConfiguration;
          if (!isCore && (isAlwaysSecondary || child.textContent.trim())) secondary.append(child);
          else if (!isCore && !child.children.length) child.hidden = true;
        });
      });
    };

    const setBuyboxOrder = (root = document) => {
      root.querySelectorAll('.product-information--inner').forEach((buybox) => {
        const config = buybox.querySelector('.pm-buybox-config');
        const addlyBundle = buybox.querySelector('n9-fbt');
        if (addlyBundle) addlyBundle.hidden = true;

        Array.from(buybox.children).forEach((child) => {
          let order = 200;
          const isInlineOffer = child.matches('.patch-picker')
            || Boolean(child.querySelector('.patch-picker'))
            || (child.textContent.includes('Heute 3 für 2 Aktion') && child.textContent.includes('NIMM3'));
          const isProductConfiguration = child.matches('.form-switcher')
            || Boolean(child.querySelector('.form-switcher'));

          if (child.matches('.pm-buybox-config')) order = 0;
          else if (child.matches('.pm-buybox-social') || child.querySelector('.pm-buybox-social')) order = 10;
          else if (child.matches('h1, .pm-buybox-title, .product-title-container') || child.querySelector(':scope > h1, .pm-buybox-title')) order = 20;
          else if (child.matches('.pm-shop-rating') || child.querySelector('.pm-shop-rating')) order = 30;
          else if (child.matches('.pm-buybox-usps') || child.querySelector('.pm-buybox-usps')) order = 35;
          else if (isProductConfiguration || child.matches('variant-selects') || child.querySelector('variant-selects')) order = 40;
          else if (isInlineOffer || child.matches('.addon-card, onetick-group-checkboxes, .checkbox-wrapper') || child.querySelector('.addon-card, onetick-group-checkboxes, .checkbox-wrapper')) order = 50;
          else if (child.matches('.pm-buybox-price, #custom-price-display, .productpreis') || child.querySelector('.pm-buybox-price, #custom-price-display, .productpreis')) order = 70;
          else if (child.matches('product-form, .product-form') || child.querySelector('.single-add-to-cart-button')) order = 80;
          else if (child.matches('n9-fbt') || child.querySelector('n9-fbt')) order = 120;
          else if (child.matches('.easify-product-options, .tpo_option-set-wrapper') || child.querySelector('.easify-product-options, .tpo_option-set-wrapper')) order = 60;
          else if (child.matches('.pm-buybox-delivery, .lb-delivery-time') || child.querySelector('.pm-buybox-delivery, .lb-delivery-time')) order = 90;
          else if (child.matches('.pm-buybox-payments, .BenefitContainer') || child.querySelector('.pm-buybox-payments, .BenefitContainer')) order = 100;
          else if (child.matches('.pm-buybox-benefits, .lb-atc-benefits') || child.querySelector('.pm-buybox-benefits, .lb-atc-benefits')) order = 110;
          else if (child.matches('.pm-buybox-product-reviews') || child.querySelector('.pm-buybox-product-reviews, .jdgm-review-snippet')) order = 115;
          else if (child.querySelector('.quantity, quantity-input')) order = 45;

          child.style.setProperty('order', String(order));
        });
      });
    };

    const positionEasifyOptions = (root = document) => {
      root.querySelectorAll('.product-information--inner').forEach((buybox) => {
        const easifyRoot = buybox.querySelector('.easify-product-options, .tpo_option-set-wrapper.tpo_has-option-set');
        if (!easifyRoot) return;

        const easifyBlock = getDirectBuyboxChild(easifyRoot, buybox);
        if (!easifyBlock) return;

        const customPrice = buybox.querySelector('.pm-buybox-price, #custom-price-display, .productpreis');
        const customPriceBlock = customPrice ? getDirectBuyboxChild(customPrice, buybox) : null;
        const addToCartHolder = easifyRoot.closest('.add_to_cart_holder');
        const easifyAtc = addToCartHolder?.querySelector('.single-add-to-cart-button');
        const priceForHolder = addToCartHolder?.contains(customPrice) ? customPrice : customPriceBlock;
        if (priceForHolder && addToCartHolder && easifyAtc) {
          if (!addToCartHolder.contains(priceForHolder) || easifyRoot.nextElementSibling !== priceForHolder) {
            easifyRoot.insertAdjacentElement('afterend', priceForHolder);
          }
          priceForHolder.style.removeProperty('order');
          return;
        }

        if (customPriceBlock && customPriceBlock !== easifyBlock) {
          buybox.insertBefore(easifyBlock, customPriceBlock);
          return;
        }

        const nativePrice = buybox.querySelector('.product-title-container > .product-price-container');
        if (nativePrice && easifyBlock.nextElementSibling !== nativePrice) {
          nativePrice.classList.add('pm-relocated-price');
          easifyBlock.insertAdjacentElement('afterend', nativePrice);
        }
      });
    };

    initializeInlineQuantity();
    deduplicateBuyboxCore();
    initializeSharedPrices();
    positionEasifyOptions();
    positionProductUsps();
    updateConditionalModules();
    setBuyboxOrder();
    moveSecondaryBuyboxContent();
    document.addEventListener('DOMContentLoaded', () => {
      deduplicateBuyboxCore();
      positionEasifyOptions();
      positionProductUsps();
      updateConditionalModules();
      setBuyboxOrder();
      initializeSharedPrices();
      moveSecondaryBuyboxContent();
    });
    document.addEventListener('tpo_loaded', () => {
      deduplicateBuyboxCore();
      positionEasifyOptions();
      positionProductUsps();
      updateConditionalModules();
      setBuyboxOrder();
      initializeSharedPrices();
      moveSecondaryBuyboxContent();
    });
    document.addEventListener('shopify:section:load', (event) => {
      initializeInlineQuantity(event.target);
      deduplicateBuyboxCore(event.target);
      initializeSharedPrices(event.target);
      positionEasifyOptions(event.target);
      positionProductUsps(event.target);
      updateConditionalModules(event.target);
      setBuyboxOrder(event.target);
      moveSecondaryBuyboxContent(event.target);
    });

    document.addEventListener('product:variant-change', (event) => {
      const sectionId = String(event.detail?.sectionId || '');
      const priceBox = document.querySelector(`[data-pm-shared-price][data-section-id="${sectionId}"]`);
      updateSharedPrice(priceBox, event.detail?.variant);
      requestAnimationFrame(() => {
        positionProductUsps();
        updateConditionalModules();
      });
    });

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticker-set-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeStickerUpsell = (root = document) => {
      const productForm = root.querySelector('product-form form') || document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
      if (!productForm || productForm.dataset.addonBound === 'true') return;

      productForm.dataset.addonBound = 'true';
      let isSubmitting = false;

      productForm.addEventListener('submit', async (event) => {
        const selectedCards = Array.from(document.querySelectorAll('[data-addon-card]')).filter((card) => {
          return card.querySelector('[data-addon-checkbox]')?.checked;
        });
        if (selectedCards.length === 0) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (isSubmitting) return;

        isSubmitting = true;
        const submitButton = productForm.querySelector('[type="submit"]');
        submitButton?.setAttribute('disabled', 'disabled');
        submitButton?.classList.add('is-loading');

        try {
          const formData = new FormData(productForm);
          const mainItem = {
            id: Number(formData.get('id')),
            quantity: Number(formData.get('quantity') || 1),
          };
          const properties = {};

          formData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.+)\]$/);
            if (propertyMatch && value !== '') properties[propertyMatch[1]] = value;
          });
          if (Object.keys(properties).length > 0) mainItem.properties = properties;
          if (formData.get('selling_plan')) mainItem.selling_plan = Number(formData.get('selling_plan'));

          const items = [mainItem];
          selectedCards.forEach((card) => {
            items.push({
              id: Number(card.dataset.addonVariantId),
              quantity: mainItem.quantity,
            });
          });

          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items }),
          });
          if (!addResponse.ok) throw new Error('Add-on add failed');

          const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

          window.setTimeout(() => {
            const drawer = document.querySelector('cart-drawer');
            if (typeof drawer?.open === 'function') drawer.open();
            else document.getElementById('cart-drawer-toggle')?.click();
          }, 250);
        } catch (error) {
          window.alert('Das Produkt konnte gerade nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.');
        } finally {
          isSubmitting = false;
          submitButton?.removeAttribute('disabled');
          submitButton?.classList.remove('is-loading');
        }
      }, true);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeStickerUpsell());
    } else {
      initializeStickerUpsell();
    }
    document.addEventListener('shopify:section:load', (event) => initializeStickerUpsell(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
